import { render } from "./balance-overview.vue?vue&type=template&id=1a11c4d0"
import script from "./balance-overview.vue?vue&type=script&lang=js"
export * from "./balance-overview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__